import React, { useState } from "react";

import PropTypes from "prop-types";
import "./style.scss";

const FloatLabel = ({ children, label, value, errors, touched }) => {
  const [focus, setFocus] = useState(false);
  const labelClass =
    focus || (value && value.length !== 0) ? "label label-float" : "label";

  return (
    <div
      className={`float-label-autocomplete ${
        errors && touched && "error-label"
      }`}
      onBlur={() => setFocus(false)}
      onFocus={() => setFocus(true)}>
      {children}
      <label className={labelClass}>{label}</label>
      <small className={"input-errors"}>{errors}</small>
    </div>
  );
};

FloatLabel.propTypes = {
  children: PropTypes.node,
  label: PropTypes.string,
  value: PropTypes.array,
  errors: PropTypes.string,
  touched: PropTypes.bool,
};

FloatLabel.defaultProps = {
  setType: () => {},
};

export default FloatLabel;
